import { jsx as _jsx } from "react/jsx-runtime";
const HorizontalSeparator = ({ classes = '' }) => {
    return _jsx("hr", { className: `min-h-[1px] w-full border-none bg-[--separator-color] ${classes}` });
};
export default HorizontalSeparator;
